import React from "react"
import { Button, ButtonLoader, ButtonReloadPage, UploadButton } from "../../components/Button"
import { CardModal, CardsInfoTitleSub } from "../../components/Card"
import ContentRegisterList from "../../components/ContentRegisterList"
import {
  Input,
  FormRow,
  Label,
  TextArea,
  SelectInput,
} from "../../components/Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { useState } from "react"
import { PickerWithType } from "../../components/DatePicker"
import { IoFilterOutline } from "react-icons/io5"
import { useRef } from "react"
import { useEffect } from "react"
import { LoadingWithLabel } from "../../components/Loading"
import { EmptyScreen } from "../../components/Empty"

const FilterModalContent = ({
  modalIsOpen,
  setModalIsOpen,
  onChange,
  filter,
  setFilter,
  optionsNote,
  tagsProject,
  values
}) => {

  const selectRef = useRef(null);
  const [value, setValue] = useState({})
  const [cleared, setCleared] = useState(false)

  const clearData = () => {
    setCleared(!cleared)
  }

  useEffect(() => {
    if(cleared){
      setValue({nota: {value: "2", label: "two"}})
    }
  },[cleared])



  return (
    <ModalPanel modalIsOpen={modalIsOpen} width={500}>
      <ModalHeader closeModal={() => setModalIsOpen(false)} title="Filtro"></ModalHeader>
      <ModalBody>
        <CardModal className="content-filter-modal">
        <div className="filter-input-select">
        <Label label={"Nota"} />
          <SelectInput
            ref={selectRef}
            isClearable
            placeholder="Selecione a Nota"
            defaultValue={filter?.nota}
            value={filter?.nota}
            options={optionsNote}
            onChange={(nota) => setFilter((filter) => ({ ...filter, nota }))}
            isOverModal={true}
          />
          <Label label={"Tag"} />
          <SelectInput
            isClearable
            placeholder="Selecione a Tag"
            defaultValue={filter?.tag}
            value={filter?.tag}
            isSearchable
            options={
              tagsProject &&
              tagsProject?.map(({ id, name }) => ({
                value: id,
                label: name,
              }))
            }
            onChange={(tag) => setFilter((filter) => ({ ...filter, tag }))}
            isOverModal={true}
          />
          
        </div>
          <>
              <Label label={"Última Alteração"} />
              <PickerWithType
                defaultValue={values?.year}
                type={1}
                onChange={onChange("year")}
                className={"class-period"}
              />
            </>
        </CardModal>
      </ModalBody>
      <ModalFooter styles={{ justifyContent: "flex-end" }}>
          <Button
            className="button-engagement"
            color="orange"
            handleClick={() => setModalIsOpen(false)}
            label={"Confirmar"}
          />
        </ModalFooter>
    </ModalPanel>
  )
}


const ContentPageScreen = ({
  filter,
  setFilter,
  data,
  tagsProject,
  onSearchContent,
  searchTerm,
  openModalEdit,
  modalIsOpen,
  setModalIsOpen,
  onChangeImage,
  register,
  control,
  isLoading,
  isLoadingSave,
  onChange,
  sendItems,
  processingFile,
  uploaded,
  handleSelectedList,
  selectedsUsers,
  clearData,
  countNotes,
  isFetching, 
  lastUpdated, 
  reload,
  values
}) => {

  const [modalFilterContent, setModalFilterContent] = useState(false)

  const optionsNote = [
    {
      value: "0",
      label: "0",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3",
      label: "3",
    },
    {
      value: "5",
      label: "5",
    },
  ]

  const optionsApplication = [
    {
      value: "5",
      label: "Total",
    },
    {
      value: "3",
      label: "Parcial",
    },
  ]

  const openModalFilter = () => {
    setModalFilterContent(true)
  }


  const selectedCard = (str) => str.includes(filter?.nota?.value)
  

  return (
    <div className="content-page-screen">
      <div className="filter-container">
        <div className="filter-input-select">
          <Input
            value={searchTerm || ""}
            placeholder={"Pesquise pelo produtor ou técnico"}
            onChange={onSearchContent}
            isWhite
            hasFocus={false}
            hasIcon={<i class="fi fi-rr-search"></i>}
          />
        </div>

        {selectedsUsers.length > 0 && (
          <div className="buttons">
            <Button handleClick={() => openModalEdit(selectedsUsers)} color="orange" label="Ação" />
          </div>
        )}
        <div className="content-page-screen__filter-modal" onClick={() => openModalFilter()}>
          <IoFilterOutline className="icon-filter" />
          <text className="text-filter">Filtrar</text>
        </div>
      </div>
      <ButtonReloadPage {...{ isFetching, isLoading, lastUpdated, reload }} />
      {isLoading ? (
        <div className="empty-screen-content">
          <LoadingWithLabel
            labelLoading={"Aguarde, enquanto estamos buscando as informações..."}
            sizeSpinner={"medium"}
            colorSpinner={"primary"}
          />
        </div>
      ) : data.length > 0  ? (
        <div className="content-page-container">
          <div className="cards-content-page=container">
            <div className="cards-content-page">
              <CardsInfoTitleSub title={countNotes?.note0 || 0} subtitle="Nota 0" className={`${selectedCard('note0') ? "cards-content-page--selected" : ""}`} />
              <CardsInfoTitleSub title={countNotes?.note2 || 0} subtitle="Nota 2" className={`${selectedCard('note2') ? "cards-content-page--selected" : ""}`} />
              <CardsInfoTitleSub title={countNotes?.note3 || 0} subtitle="Nota 3" className={`${selectedCard('note3') ? "cards-content-page--selected" : ""}`} />
              <CardsInfoTitleSub title={countNotes?.note5 || 0} subtitle="Nota 5" className={`${selectedCard('note5') ? "cards-content-page---selected" : ""}`} />
            </div>
          </div>

          <ContentRegisterList
            data={data}
            openModalEdit={openModalEdit}
            loading={isLoading}
            onSelect={handleSelectedList}
            selecteds={selectedsUsers}
          />
        </div>
      ) : (
        <EmptyScreen label="Não conseguimos encontrar as informações" />
      )}
      <ModalPanel modalIsOpen={modalIsOpen}>
        <ModalHeader closeModal={() => setModalIsOpen(false)} title="Mudar Estado" />
        <ModalBody>
          <CardModal>
            <FormRow>
              <Label label="Aplicação" />
              <SelectInput
                control={control}
                handleChange={onChange("application")}
                closeMenuOnSelect={true}
                isSearchable={false}
                isMulti={false}
                name="application"
                options={optionsApplication}
              />
            </FormRow>
            <FormRow>
              <Label label="Observação" />
              <TextArea
                name="observation"
                placeholder={"Digite aqui a observação"}
                resize={"none"}
                register={register("observation")}
              />
            </FormRow>
            <FormRow className="mt-20">
              <UploadButton
                color="orange"
                label={
                  !uploaded ? "Adicionar Arquivos de Evidência" : "Editar Arquivos de Evidência"
                }
                onFileChange={(e) => onChangeImage(e)}
                name="picture"
                accept="image/png"
              />
            </FormRow>
          </CardModal>
        </ModalBody>
        <ModalFooter styles={{ justifyContent: "center !important" }}>
          <ButtonLoader
            loading={isLoadingSave || processingFile}
            messageProcess={processingFile ? "Aguarde, fazendo upload..." : "Salvando"}
            label={"Salvar"}
            color="orange"
            handleClick={sendItems}
          />
        </ModalFooter>
      </ModalPanel>
      <FilterModalContent
        {...{
          modalIsOpen: modalFilterContent,
          setModalIsOpen: setModalFilterContent,
          onChange,
          searchTerm,
          onSearchContent,
          filter,
          setFilter,
          optionsNote,
          tagsProject,
          clearData,
          values,
        }}
      />
    </div>
  )
}

export default ContentPageScreen
